//import React from 'react'

// questionnaire_pre,  questionnaire_post
export var parentQuestionnaire = {
    id: "",
    interviewer: "",
    date: "",
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    q10: "",
    q11: "",
    q12: "",
    q13: "",
    q14: "",
    q15: "",
    q16: "",
    q17: "",
    q18: "",
    q19: "",
    q20: "",
    q21: "",
    q22: "",
    q23: "",
    q24: "",
    q25: "",
    q26: "",
    q27: "",
    q28: "",
    s1: "",
    s2: "",
    s3: "",
    s4: "",
    s5: "",
    s6: "",
    s7: "",
    s8: "",
    s9: "",
    s10: "",
    s11: "",
    s12: "",
    r1: "",
    r2: "",
    r3: "",
    r4: "",
    r5: "",
    comments: ""
}
export const pqConvert = {
    "כלל לא":           "1-כלל לא",
    "במידה מעטה מאוד": "2-במידה מעטה מאוד",
    "במידה מעטה":      "3- במידה מעטה",
    "במידה בינונית":    "4-במידה בינונית",
    "במידה רבה":        "5-במידה רבה",
    "במידה רבה מאוד":   "6-במידה רבה מאוד"
}

export var family_products_services= {
    q1: "",
    q101: "",
    q102: "",
    q103: "",
    q104: "",
    q105: "",
    q106: "",
    q107: "",
    q108: "",
    q109: "",
    q110: "",
    q201: "",
    q202: "",
    q203: "",
    q204: "",
    q205: "",
    q206: "",
    q207: "",
    q208: "",
    q209: "",
    q210: "",
    q211: "",
    q212: "",
    q213: "",
    q214: "",
    q215: "",
    q31: "",
    q32: "",
    q33: "",
    q401: "",
    q402: "",
    q403: "",
    q404: "",
    q405: "",
    q406: "",
    q407: "",
    q408: "",
    q409: "",
    q410: "",
    q411: "",
    q412: "",
    q413: "",
    comments: ""
}